import { useSelector } from 'react-redux'
import StateType from '../../utils/types/states'

const selectGlobalCustomFields = (state: StateType) => state.adminElement.customFields
const selectLoadingGlobalCustomFields = (state: StateType) => state.adminElement.loading

export const useGlobalCustomFields: () => any | [] = () => useSelector(selectGlobalCustomFields)
export const useLoadingGlobalCustomFields: () => boolean = () => useSelector(selectLoadingGlobalCustomFields)
